/**
 * Both the desktop bottom bar and the mobile nav carry data-bottom-bar, and the one that is
 * display:none measures as a 0×0 box at the top-left. Returns the first one that is painted.
 */
export function getVisibleBottomBarRect(): DOMRect | null {
  for (const bar of document.querySelectorAll<HTMLElement>("[data-bottom-bar]")) {
    const rect = bar.getBoundingClientRect();
    if (rect.height > 0) return rect;
  }
  return null;
}

/** Pixels a popover must stay clear of, so it sits above the painted bottom bar. */
export function bottomBarCollisionPadding(gap = 8): number {
  if (typeof window === "undefined") return gap;
  const bar = getVisibleBottomBarRect();
  const inset = bar ? window.innerHeight - bar.top : 0;
  return Math.max(gap, Math.ceil(inset) + gap);
}
